import { useTranslation } from "react-i18next";
import { LoadingPanel, ErrorPanel } from "~/components/panels";

import { useAcpFeedPreview } from "~/pages/product-details/tabs/raw-data-tab/hooks/use-acp-feed-preview";
import { AcpFeedPreviewSection } from "./acp-feed-preview-section";

export const AcpTabContent = () => {
  const { t } = useTranslation(["productDetails"]);
  const { data, isLoading, error } = useAcpFeedPreview();

  if (isLoading) {
    return <LoadingPanel loadingText={t("productDetails:rawData.loading")} />;
  }

  if (error) {
    return (
      <ErrorPanel
        title={t("productDetails:rawData.acp.title")}
        errorTitle={t("productDetails:rawData.error.title")}
        errorMessage={t("productDetails:rawData.error.message")}
      />
    );
  }

  if (!data) return null;

  return (
    <div data-testid="acp-feed-preview-section">
      <AcpFeedPreviewSection data={data} />
    </div>
  );
};
